package net.frozenbit.games.soundgame.ui

import androidx.compose.animation.AnimatedContentScope
import androidx.compose.animation.SharedTransitionScope
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import net.frozenbit.games.soundgame.components.CountdownTimer
import net.frozenbit.games.soundgame.components.JoinCode
import net.frozenbit.games.soundgame.components.PlayerTag
import net.frozenbit.games.soundgame.theme.Typography
import net.frozenbit.games.soundgame.utils.Countdown
import net.frozenbit.games.soundgame.viewmodels.presentation.PlayerTagData

@Composable
fun SharedTransitionScope.HostPromptSelectionScreen(
    screenTransitions: AnimatedContentScope,
    joinCode: String,
    who: PlayerTagData,
    countdownText: Countdown.Tick?,
) {
    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center,
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(16.dp, Alignment.Top),
            modifier = Modifier
                .padding(8.dp)
        ) {
            countdownText?.let {
                CountdownTimer(it)
            }
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically,
            ) {
                PlayerTag(
                    who,
                    modifier = Modifier.sharedElement(
                        rememberSharedContentState(key = "jury"),
                        screenTransitions,
                    )
                )
                Text(
                    text = " wählt eine Kategorie",
                    fontSize = Typography.Host.bodySize,
                )
            }
        }
        JoinCode(
            joinCode,
            modifier = Modifier
                .align(Alignment.BottomEnd)
                .padding(16.dp)
        )
    }
}